import React, { useState, useImperativeHandle, useRef } from 'react';
import { LoginInputContainer, LoginInputStyled, ErrorText } from './LoginInput.styled';


const LoginInputComponent = (props, ref) => {
  const [errorText, setErrorText] = useState('');
  const inputRef = useRef(null);
  
  const validate = async (value) => {
    if (props.required && !value) {
      setErrorText(`${props.placeholder} is required`);
      return false;
    }
    if (props.validate) {
      try {
        await props.validate(value);
        setErrorText('');
        return true;
      } catch (error) {
        setErrorText(error.message);
        return false;
      }
    }
    return true;
  }

  useImperativeHandle(ref, () => ({
    validate,
    focus: () => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    },
  }));

  return (
    <LoginInputContainer
      style={{...props.style}} 
    >
      <LoginInputStyled
        ref={inputRef}
        value={props.value}
        onChange={(e) => {
          setErrorText('');
          props.onChange(e);
        }}
        onBlur={async (e) => {
          await validate(e.target.value);
          if (props.onBlur) {
            props.onBlur();
          }
        }}
        type={props.type}
        name={props.name}
        placeholder={props.placeholder}
        required={props.required}
        onKeyDown={props.onKeyDown}
        onKeyUp={props.onKeyUp || props.onKeyPress}
      />
    {
      (!!errorText || props.errorText) &&
        <ErrorText>{errorText || props.errorText}</ErrorText>
    }
    </LoginInputContainer>
  )
}
export default React.forwardRef(LoginInputComponent);